var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrinkLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 141.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#69c0b3;}.cls-4{fill:#14263d;}.cls-5{clip-path:url(#clippath-1);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.82,
    y: 2.71,
    width: 292.96,
    height: 133.97
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.82,
    y: 2.71,
    width: 292.96,
    height: 133.97
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brink_Logo"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m5.62,125.13c0-6.86,5.19-11.55,11.71-11.55,5.09,0,7.93,2.68,9.51,5.46l-4.08,2.01c-.94-1.81-2.95-3.25-5.42-3.25-3.88,0-6.83,3.11-6.83,7.33s2.95,7.33,6.83,7.33c2.48,0,4.49-1.41,5.42-3.25l4.08,1.97c-1.61,2.78-4.42,5.49-9.51,5.49-6.53,0-11.71-4.69-11.71-11.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m54.35,113.58c6.76,0,11.68,4.82,11.68,11.55s-4.92,11.55-11.68,11.55-11.65-4.82-11.65-11.55,4.92-11.55,11.65-11.55m0,4.22c-4.12,0-6.76,3.15-6.76,7.33s2.64,7.33,6.76,7.33,6.79-3.18,6.79-7.33-2.68-7.33-6.79-7.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "103.42 136.28 103.42 120.21 97.13 136.28 95.05 136.28 88.76 120.21 88.76 136.28 84.01 136.28 84.01 113.95 90.67 113.95 96.09 127.88 101.51 113.95 108.2 113.95 108.2 136.28 103.42 136.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.83 136.28 146.83 120.21 140.54 136.28 138.46 136.28 132.17 120.21 132.17 136.28 127.42 136.28 127.42 113.95 134.08 113.95 139.5 127.88 144.92 113.95 151.62 113.95 151.62 136.28 146.83 136.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "170.83 136.28 170.83 113.95 186.63 113.95 186.63 118.04 175.58 118.04 175.58 122.89 186.39 122.89 186.39 126.97 175.58 126.97 175.58 132.16 186.63 132.16 186.63 136.28 170.83 136.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m217.96,136.28l-4.38-8h-3.48v8h-4.75v-22.32h10.44c4.65,0,7.5,3.05,7.5,7.2s-2.48,6.06-4.89,6.63l5.02,8.5h-5.46Zm-2.88-18.24h-4.99v6.16h4.99c1.91,0,3.35-1.2,3.35-3.08s-1.44-3.08-3.35-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m240.02,125.13c0-6.86,5.19-11.55,11.71-11.55,5.09,0,7.93,2.68,9.51,5.46l-4.08,2.01c-.94-1.81-2.95-3.25-5.42-3.25-3.88,0-6.83,3.11-6.83,7.33s2.95,7.33,6.83,7.33c2.48,0,4.49-1.41,5.42-3.25l4.08,1.97c-1.61,2.78-4.42,5.49-9.51,5.49-6.53,0-11.71-4.69-11.71-11.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "278.64 136.28 278.64 113.95 294.44 113.95 294.44 118.04 283.39 118.04 283.39 122.89 294.2 122.89 294.2 126.97 283.39 126.97 283.39 132.16 294.44 132.16 294.44 136.28 278.64 136.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.32,2.77l15.21-.06s0,19.67,0,29.5c4.89-2.82,9.97-4.97,15.66-5.44,8.24-.85,16.31,1.14,23.25,5.64-2.83,4.42-5.74,8.79-8.58,13.19-5.32-3.4-11.84-4.23-17.79-2.08-6.86,2.34-11.86,8.92-12.47,16.11-.76,7.54,3.27,15.09,9.92,18.7,7.08,4.02,16.4,2.91,22.39-2.6,3.95-3.59,6.26-9.66,6.4-15.04,0-.32-.25-.58-.57-.58l-6.31.03c-.45,0-.72-.5-.48-.88,2.18-3.35,10.05-15.46,14.65-22.49.22-.34.72-.34.95,0,4.87,7.5,9.77,14.99,14.63,22.48.24.38-.02.88-.47.88-2.06,0-4.12,0-6.17,0-.32,0-.57.26-.57.58.11,9.36-3.45,18.5-10.03,25.18-6.36,6.55-15.27,10.42-24.4,10.54-8.22.2-16.41-2.6-22.77-7.81-2.12-1.7-4.02-3.65-5.68-5.78-4.84-6.24-7.32-13.99-7.26-21.89L3.32,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.48,2.86h14.51c.31,0,.57.25.57.56l.11,13.26c0,.32-.25.57-.57.57l-14.63.03c-.31,0-.57-.25-.57-.57V3.43c0-.31.25-.57.57-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m121.14,25.85c.01,4.81,0,9.62.01,14.43-2.74-.11-5.35-.25-8.01.49-4.79,1.19-8.93,4.88-10.37,9.64-.95,2.89-.68,5.6-.71,8.6,0,12.16,0,24.31,0,36.47-5.27.04-10.54,0-15.81.03-.02-13,0-25.99-.01-38.98-.01-5.87,1.01-11.61,3.87-16.8,3.09-5.71,8.33-10.06,14.46-12.17,5.38-1.99,10.92-2.15,16.56-1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "132.92 25.61 148.67 25.64 148.67 95.48 132.92 95.51 132.92 25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m189,25.78c6.42-.58,13.17.09,19,3.02,5.22,2.58,9.57,6.84,12.1,12.1,2.43,4.92,3.18,10.19,3.21,15.63-.01,12.99,0,25.99,0,38.98-5.27-.02-10.53.02-15.8-.02.01-13.19-.01-26.39.01-39.59.01-2.78-.38-5.63-1.66-8.12-1.59-3.17-4.65-5.62-8.12-6.4-3.06-.7-6.35-.72-9.38.13-4.48,1.2-8.35,4.9-9.55,9.41-.55,1.85-.61,3.71-.63,5.62.02,12.99,0,25.99.02,38.98h-15.69c.01-13.41-.01-26.83,0-40.24.06-7.98,2.96-15.89,8.77-21.47,4.8-4.6,11.13-7.37,17.73-8.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m252.27,25.62v28.29c4.2-.03,8.41.07,12.62-.03,4.71-.13,9.54-2.32,12.25-6.27,2.1-3,2.85-6.75,2.88-10.36,0-3.88-.02-11.64-.02-11.64h15.77s.05,10.55-.03,15.82c-.16,5.75-2.16,11.31-6.34,15.35-2.08,2.05-4.55,3.22-7.11,4.52,2.63,1.32,5.16,2.65,7.24,4.79,4.2,4.07,6.06,9.7,6.22,15.46.06,4.62.02,13.87.02,13.87h-15.47s.45-11.73-1.4-16.85c-1.92-5.43-7.11-8.98-12.75-9.52-4.58-.43-9.25-.1-13.86-.2-.02,8.88,0,26.65,0,26.65h-15.76s-.09-46.65.07-69.82l15.69-.07Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrinkLogoDark);
export default __webpack_public_path__ + "static/media/brink-logo-dark.2588138c3391611367f8441d1338eefd.svg";
export { ForwardRef as ReactComponent };